var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccessTickFilled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 147,
    height: 147,
    viewBox: "0 0 147 147",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_441_71419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.5 0C32.9705 0 0 32.9705 0 73.5C0 114.03 32.9705 147 73.5 147C114.03 147 147 114.03 147 73.5C147 32.9705 114.03 0 73.5 0Z",
    fill: "#32B2AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.754 57.9239L70.9411 97.7356C69.7466 98.93 68.1788 99.5312 66.6109 99.5312C65.043 99.5312 63.4751 98.93 62.2807 97.7356L42.3748 77.8297C39.9792 75.4353 39.9792 71.5638 42.3748 69.1693C44.7692 66.7738 48.6396 66.7738 51.0352 69.1693L66.6109 84.745L102.094 49.2635C104.488 46.8679 108.358 46.8679 110.754 49.2635C113.148 51.6579 113.148 55.5283 110.754 57.9239Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_441_71419"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 147,
    height: 147,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessTickFilled);
export default __webpack_public_path__ + "static/media/successTickFilled.2013a6777b69c2ffc3f697e0f5b667a6.svg";
export { ForwardRef as ReactComponent };